// eslint-disable-next-line import/prefer-default-export
export const invertedMessages = {
  Refresh: 'Refresh.ATTESTATIONS',
  Reset: 'CERTS_RESET',
};
